import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectPublishingMode } from 'core/store/selectors/selectPublishingMode'
import { cancelEditingGroup } from 'partner360/features/assortment/assortmentSlice'
import {
  selectAssortmentGroupsData,
  selectAssortmentItemsData,
} from 'partner360/features/assortment/selectors'
import {
  requestAssortmentGroups,
  requestAssortmentItems,
} from 'partner360/features/assortment/thunks'
import { IGroupedData } from 'partner360/widgets/assortmentTab/context/models/IGroupedData'

interface IParams {
  partnerId: string
  programType: ProgramTypes
  categoryName: string
  fYear: number
}

export const useCategoryAssortment = ({ partnerId, programType, categoryName, fYear }: IParams) => {
  const dispatch = useAppDispatch()

  const groups = useSelector(selectAssortmentGroupsData)
  const items = useSelector(selectAssortmentItemsData)
  const isEditingMode = useSelector(selectPublishingMode)

  const groupedData = useMemo(() => {
    return groups.reduce<IGroupedData[]>((acc, group) => {
      acc.push({
        ...group,
        children: items.filter((it) => it.AssortmentGroupId === group.EntryId),
      })
      return acc
    }, [])
  }, [groups, items])

  useEffect(() => {
    dispatch(
      requestAssortmentGroups({
        fYear,
        partnerId,
        programType,
        category: categoryName,
      })
    )
    dispatch(
      requestAssortmentItems({
        fYear,
        partnerId,
        programType,
        category: categoryName,
      })
    )
  }, [dispatch, partnerId, programType, categoryName, fYear])

  useEffect(() => {
    if (!isEditingMode) {
      dispatch(cancelEditingGroup())
    }
  }, [dispatch, isEditingMode])

  return groupedData
}
